import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import {Settings} from "luxon";

const resources = {
    de: {
        translation: {
            common: {
                continue: 'Weiter',
                confirmString: 'bestätigen'
            },
            breeders: {
                filter: 'Züchter suchen',
                pickNewOwner: 'Neuen Besitzer für {{animal}} auswählen',
                enterExternal: 'Name des externen Züchters eingeben',
                notFound: 'Keine Züchter gefunden',
                ownerChangeConfirmTitle: 'Tierbesitz übertragen?',
                ownerChangeConfirmNotice: 'Diese Aktion kann nicht rückgängig gemacht werden!',
                ownerRequireConfirmString: 'Gib "{{confirmString}}" ein um das Tier an einen anderen Züchter übertragen zu können',
                ownershipTransferSuccess: 'Besitzer geändert'
            },
            treatmentType: {
                weighing: "Wiegung",
                othermedication: "Sonstige Medikation",
                other: "Sonstige Behandlung",
                spittest: "Spucktest",
                ultrasound: "Ultraschall",
                vaccination: "Impfung",
                bodyscore: "Bodyscore",
                vitaminsandminerals: "Vitamine und Mineralstoffe",
                antiparasitics: "Parasitenbehandlung"
            },
            herd: {
                filter: "Herde filtern"
            },
            gestation: {
                conflict: {
                    already_active: "Stute hat bereits eine aktive Trächtigkeit am {{date}}",
                },
            },
            breeder_create_success: "Konto erfolgreich angelegt",
            registered_at: "Registriert bei",
            breed: {
                HUACAYA: 'Huacaya',
                SURI: 'Suri',
            },
            sex: {
                MALE: 'männlich',
                FEMALE: 'weiblich',
                UNKNOWN: 'unbekannt',
            },
            color: {
                BAY_BLACK: 'Bay black',
                BEIGE: 'Beige',
                DARK_BROWN: 'Dark brown',
                DARK_FAWN: 'Dark fawn',
                DARK_ROSE_GREY: 'Dark rose grey',
                DARK_SILVER_GREY: 'Dark silver grey',
                LIGHT_BROWN: 'Light brown',
                LIGHT_FAWN: 'Light fawn',
                LIGHT_ROSE_GREY: 'Light rose grey',
                LIGHT_SILVER_GREY: 'Light silver grey',
                MEDIUM_BROWN: 'Medium brown',
                MEDIUM_FAWN: 'Medium fawn',
                MEDIUM_ROSE_GREY: 'Medium rose grey',
                MEDIUM_SILVER_GREY: 'Medium silver grey',
                MULTICOLOR: 'Multicolor',
                TRUE_BLACK: 'True black',
                UNKNOWN: 'Unbekannt',
                WHITE: 'Weiß',
                empty: 'keine',
            },
            eyecolor: {
                UNKNOWN: 'Keine Angabe',
                DARK: 'Dunkel',
                DARK_BROWN: 'Dunkelbraun',
                BLACK: 'Schwarz',
                BLUE: 'Blau',
                GREY: 'Grau',
            },
            identifier: {
                type: {
                    CHIP: 'Chip',
                    EAR_TAG: 'Ohrmarke',
                },
            },
            helpPage: {
                title: "Hilfeseite",
                searchLabel: "Hilfeartikel suchen",
                articleTitle: "{{title}}",
                articleSummary: "{{summary}}",
                readMore: "Weiterlesen",
                watchVideo: "Video ansehen",
                deleteTitle: "Hilfeartikel löschen",
                cancelButtonText: "Abbrechen",
                okButtonText: "Löschen",
                reachOut: "Deine Frage war nicht dabei? Dann sende uns eine"
            },
            helpArticleEditor: {
                editTitle: "Hilfeartikel bearbeiten",
                createTitle: "Neuen Hilfeartikel erstellen",
                titleLabel: "Titel",
                summaryLabel: "Zusammenfassung",
                fullUrlLabel: "Vollständige URL",
                videoUrlLabel: "Video-URL (optional)",
                saveButton: "Artikel speichern"
            },
            monthly: {
                plan: {
                    name: "Monatlich",
                    description: "pro Monat",
                },
            },
            yearly: {
                plan: {
                    name: "Jährlich",
                    description: "pro Jahr",
                },
            },
            footer: {
                ariaLabel: "Rechtliches und Kontakt",
                imprint: {
                    label: "Impressum",
                    url: "https://www.alpacuna.com/de/impressum/",
                },
                terms: {
                    label: "AGB",
                    url: "https://www.alpacuna.com/de/rechtliches/alpacuna-agb/",
                },
                privacy: {
                    label: "Datenschutz",
                    url: "https://www.alpacuna.com/de/rechtliches/alpacuna-datenschutzerklarung/",
                },
                security: {
                    label: "Sicherheit & Datenschutzpraktiken",
                    url: "https://www.alpacuna.com/de/rechtliches/sicherheits-und-datenschutzpraktiken/",
                },
                contact: {
                    label: "Kontakt: {{email}}",
                },
            },
            subscription: {
                resumeCheckout: {
                    title: "Abo fortsetzen",
                    description: "Für dein Konto besteht kein gültiges Abo. Wähle einen Plan, um dein Abo fortzusetzen.",
                    descriptionTrial: "Deine Testphase läuft ohne hinterlegte Zahlung. Wähle einen Plan, damit dein Zugang nach der Testphase nahtlos weiterläuft.",
                    button: "Weiter zur Zahlung",
                    error: "Die Zahlung konnte nicht gestartet werden. Möglicherweise besteht bereits ein aktives Abo. Bitte lade die Seite neu oder versuche es später erneut.",
                },
                status: {
                    trial: "Testphase endet am {{date}}",
                    active: "Aktiv",
                    activeRenewing: "Aktiv, verlängert sich automatisch",
                    cancelledAtEnd: "Gekündigt zum Laufzeitende",
                    cancelled: "Gekündigt",
                    expired: "Abgelaufen",
                },
                pastDue: {
                    message: "Die letzte Zahlung ist fehlgeschlagen. Bitte aktualisiere dein Zahlungsmittel im Kundenportal, damit dein Zugang nicht endet.",
                },
                customerPortal: {
                    open: "Kundenportal öffnen",
                    hint: "Rechnungen, Zahlungsmittel und Kündigung verwalten",
                    openError: "Das Kundenportal konnte nicht geöffnet werden.",
                },
            },
            checkoutSuccess: {
                title: "Zahlung erfolgreich!",
                message: "Vielen Dank! Dein Abo wurde erfolgreich abgeschlossen und dein Konto ist startklar.",
                hint: "Du kannst dich jetzt mit deinen Zugangsdaten bei Alpacuna Herds anmelden. Eine Bestätigung erhältst du außerdem per E-Mail.",
                hintLoggedIn: "Du kannst Alpacuna Herds jetzt nutzen. Eine Bestätigung erhältst du außerdem per E-Mail.",
                toLogin: "Jetzt einloggen",
                toApp: "Zu Alpacuna Herds",
                direct: {
                    title: "Alles bereit",
                    message: "Hier gibt es nichts zu bestätigen.",
                },
            },
            signupBreeder: {
                stepPlan: "Plan",
                stepAccount: "Account",
                stepFarmAndOwner: "Hof & Besitzer",
                stepAddress: "Adresse",
                stepConfirmation: "Bestätigung",
                title: "Registriere dich als Züchter",
                back: "Zurück",
                next: "Weiter",
                submitting: "Lädt...",
                toPayment: "Weiter zur Zahlung →",
                errors: {
                    conflict: "Benutzername oder E-Mail-Adresse ist bereits registriert.",
                    generic: "Die Registrierung konnte nicht abgeschlossen werden. Bitte versuche es erneut. Besteht das Problem weiter, nutze den Support-Kontakt unten.",
                    noProduct: "Dein Konto wurde angelegt, aber der gewählte Plan konnte nicht ermittelt werden. Logge dich ein und setze dein Abo in den Abo-Einstellungen fort.",
                    toStepOne: "Zurück zu Schritt 1",
                    toLogin: "Zum Login",
                },
                signupSuccess: "Registrierung erfolgreich. Du kannst dich nun einloggen.",
                support: "Fragen oder Probleme? Wir helfen gerne:",
                checkoutError: {
                    message: "Dein Konto wurde angelegt, aber die Zahlung konnte nicht gestartet werden. Du kannst es erneut versuchen oder dich einloggen und dein Abo später in den Abo-Einstellungen fortsetzen.",
                    retry: "Erneut versuchen",
                    toLogin: "Zum Login",
                },
                plan: {
                    title: "Plan wählen",
                    subtitle: "Starte mit 30 Tagen kostenlos. Jederzeit kündbar.",
                    price: "{{price, number(minimumFractionDigits: 2)}} {{currency}}",
                    taxIncluded: "inkl. MwSt.",
                    taxExcluded: "zzgl. MwSt.",
                    yearlyBadge: "2 Monate gratis",
                    loadError: "Die Pläne konnten nicht geladen werden. Bitte versuche es später erneut.",
                },
                account: {
                    title: "Account erstellen",
                    subtitle: "Mit diesen Zugangsdaten meldest du dich bei Alpacuna Herds an.",
                    emailLabel: "E-Mailadresse",
                    emailPlaceholder: "name@example.com",
                    usernameLabel: "Benutzername",
                    usernamePlaceholder: "z. B. alpenhof_maier",
                    passwordLabel: "Passwort",
                    passwordPlaceholder: "Mindestens 8 Zeichen",
                },
                farm: {
                    title: "Hof & Besitzer",
                    subtitle: "Informationen zu deinem Betrieb und der verantwortlichen Person.",
                    ownersSection: "Besitzer",
                    farmOrVatRequired: "Es wird eine Hofnummer oder Steuernummer benötigt.",
                },
                address: {
                    title: "Adresse",
                    subtitle: "Die Adresse deines Betriebs.",
                },
                confirmation: {
                    title: "Bestätigung",
                    subtitle: "Bitte prüfe deine Angaben vor dem Abschluss.",
                    planSummary: "{{name}} – {{price}} {{tax}}",
                    selectedPlan: "Gewählter Plan",
                    trialNote: "30 Tage kostenlos. Jederzeit kündbar.",
                    farmSection: "Hof",
                    summaryFarmName: "Hofname",
                    summaryOwner: "Besitzer",
                    summaryAddress: "Adresse",
                    summaryEmail: "E-Mail",
                    termsLabel: "Ich habe die <1>AGB</1> gelesen und akzeptiere sie.",
                    privacyLabel: "Ich habe die <1>Datenschutzerklärung</1> zur Kenntnis genommen.",
                    paymentNote: 'Nach dem Klick auf <1>„Weiter zur Zahlung"</1> wirst du zu unserem sicheren Zahlungsanbieter weitergeleitet.',
                },
            },
            admin: {
                featureFlags: {
                    title: "Feature Flags",
                    filter: {
                        search: "Flags filtern",
                        type: "Typ",
                        allTypes: "Alle Typen",
                        overriddenOnly: "Nur überschrieben"
                    },
                    columns: {
                        key: "Flag",
                        type: "Typ",
                        defaultValue: "Standardwert",
                        currentValue: "Aktueller Wert",
                        value: "Wert",
                        overridden: "Überschrieben",
                        actions: "Aktionen"
                    },
                    status: {
                        overridden: "Überschrieben",
                        default: "Standard"
                    },
                    actions: {
                        edit: "Bearbeiten",
                        save: "Speichern",
                        cancel: "Abbrechen",
                        reset: "Auf Standard zurücksetzen"
                    },
                    edit: {
                        prompt: "{{type}}-Wert eingeben:"
                    },
                    tooltip: {
                        defaultValue: "{{value}}"
                    },
                    noFlagsFound: "Keine Feature Flags gefunden"
                }
            },
        },
    }
};

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: "de",
        interpolation: {
            escapeValue: false,
        },
    });

Settings.defaultLocale = i18next.language;
i18next.on('languageChanged', (language) => {
    Settings.defaultLocale = language;
});

export default i18next;
